import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'
import ReactDatePicker from 'react-datepicker'

import Input from 'components/Input'
import getUnixDateTime from 'utils/get-unix-date-time'
import getUnixDateFromMoment from 'utils/get-unix-date-from-moment'

import 'react-datepicker/dist/react-datepicker-cssmodules.css'
import './InputDate.scss'

export default class InputDate extends React.Component {
  static propTypes = {
    //value: PropTypes.number,
    onChange: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      date: (props.value && moment(getUnixDateTime(props.value))) || null,
    }
  }

  handleChange = (date) => {
    const { onChange } = this.props

    this.setState({ date })

    if (onChange) onChange(getUnixDateFromMoment(date))
  }

  render() {
    const { date } = this.state
    const format = 'YYYY-MM-DD'

    return (
      <ReactDatePicker
        customInput={<Input icon="calendar" />}
        dateFormat={format}
        placeholder={format}
        selected={date}
        onChange={this.handleChange}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/InputDate/InputDate.js